import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  Input,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { NbCalendarCell, NbTooltipModule, NbDateService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import {
  Attendance,
  AttendanceService,
} from './attendance.service';

@Component({
  selector: 'app-attendance-day-cell',
  standalone: true,
  imports: [NgClass, NbTooltipModule, CommonModule],
  template: `
    <div
      class="cell-content "
      [ngClass]="statusClass"
      [class.selected-date]="isSelected"
      [class.today-cell]="isTodayCell"
      [class.tooltip-container]="type === 'regularization'"
      (click)="onClick($event)"
      [nbTooltip]="data?.workingStatus || ''"
      [nbTooltipDisabled]="!data"
    >
      {{ date.getDate() }}
    </div>
  `,
  styleUrls: ['./attendance-day-cell.component.scss'],
})
export class AttendanceDayCellComponent
  implements NbCalendarCell<Date, any>, OnInit, OnDestroy
{
  @Input() date!: Date;
  data!: Attendance | undefined;
  type!:string;
  
  /** This is no longer used by nb-calendar directly, but for selection logic */
  select = new EventEmitter<Date>();

  isSelected = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private attendanceService: AttendanceService,
    protected dateService: NbDateService<Date>
  ) {}

  ngOnInit(): void {
    // Subscription to check if this cell's date is selected
    this.subscription.add(
      this.attendanceService.selectedDates$.subscribe((selectedDates) => {
        const displayDate = this.formatDisplay(this.date);
        this.isSelected = selectedDates.includes(displayDate);
      })
    );

     this.subscription.add(
      this.attendanceService.type$.subscribe(type => {
        this.type = type;
      })
    );

    // Subscription to get the attendance status (Miss Punch, etc.)
    this.subscription.add(
      this.attendanceService.attendanceData$.subscribe((attendanceData) => {
        this.data = attendanceData.find(
          (d) => d.date === this.formatISO(this.date)
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  
  onClick(event: MouseEvent): void {
    event.stopPropagation();
    console.log(this.data)

    const normalizedStatus = (this.data?.workingStatus || '')
      .toLowerCase()
      .replace(/[^a-z]/g, '');
    const isMissPunch = normalizedStatus.includes('misspunch');
    console.log("Is miss punch",isMissPunch)
    const isWeekend = this.date.getDay() === 0 || this.date.getDay() === 6;

    if (isMissPunch && !isWeekend) {
      this.select.emit(this.date);
    }
  }


  private formatISO(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date.getDate()).padStart(2, '0')}`;
  }

  private formatDisplay(date: Date): string {
    const day = String(this.dateService.getDate(date)).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = this.dateService.getYear(date).toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  get statusClass(): string {
    // Only apply status class if the date is not selected
    // if (this.isSelected) {
    //   return '';
    // }
    return (
      this.data?.workingStatus?.toLowerCase()?.replace(/\s+/g, '-') || ''
    );
  }

  get isTodayCell(): boolean {
    const today = this.dateService.today();
    return (
      this.date.getFullYear() === today.getFullYear() &&
      this.date.getMonth() === today.getMonth() &&
      this.date.getDate() === today.getDate()
    );
  }
}
